<script setup lang="ts">
/**
 * Footer: ITO Consult logo (link) on the left, centered copyright, legal
 * links (Impressum, Datenschutz, AGB) on the right.
 */
const links = [
  { label: 'Impressum', to: 'https://ito-consult.de/impressum' },
  { label: 'Datenschutz', to: 'https://ito-consult.de/datenschutz' },
  { label: 'AGB', to: 'https://ito-consult.de/agb' },
]
</script>

<template>
  <footer class="relative z-10 bg-white">
    <div class="container flex flex-col items-center gap-3 py-8 lg:grid lg:grid-cols-3 lg:gap-4">
      <div class="w-full lg:justify-self-start">
        <ItoLogo class="w-[55px] text-text-muted" />
      </div>
      <p class="text-sm text-text-muted lg:justify-self-center">
        &copy; {{ new Date().getFullYear() }} ITO Consult
      </p>
      <div class="flex items-center gap-4 lg:justify-self-end">
        <a
          v-for="link in links"
          :key="link.label"
          :href="link.to"
          rel="noopener noreferrer"
          class="rounded-md px-2.5 py-1.5 text-xs font-medium text-text-muted"
        >
          {{ link.label }}
        </a>
      </div>
    </div>
  </footer>
</template>
